export default "__VITE_ASSET__DEz0nayn__"